// --------------------------------------------------------------------------
// #138 - Social Reward Modal
// --------------------------------------------------------------------------
// Author:      Vicki Keeley
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var postal = require('postal');
var channel = postal.channel('modals');

module.exports = function (options) {
    var context = options.context;
    var $progressLink = context.find('.progress');
    var $steps = context.find('.social-reward-modal__step');
    var $download = context.find('.download');
    var $share = context.find('.share');
    var $closeLink = context.find('.close-link');

    // scroll to the top of the modal window
    function scrollTo(offset) {
        $('html, body').animate({
            scrollTop: offset - 10
        }, 500);
    }

    // show/hide content depending on the choices the user makes
    function progress($el) {
        var $modal = $el.parents('.social-reward-modal');
        var step = $el.data('step');
        var offset = $modal.parents('.modal').offset().top;

        $modal.find($steps).hide();
        $modal.find($('.social-reward-modal__step' + step)).show();

        scrollTo(offset);
    }

    // initialise the modal event listeners
    function initEvents() {
        $progressLink.on('click', function (e) {
            e.preventDefault();

            var $el = $(this);
            progress($el);
        });

        $download.on('click', function () {
            progress($(this));
        });

        $share.on('click', function (e) {
            e.preventDefault();
            var $shareOptions = $(this).parents('.social-reward-modal').find('.social-reward-modal__share-options');

            $(this).hide();
            $shareOptions.addClass('share-open');
        });

        $closeLink.on('click', function (e) {
            e.preventDefault();
            $(this).parents('.modal').removeClass('is-visible');
            $('.modal__mask').hide();
        });

        // listens to an event published on the modal component when a modal is opened. receives $modal opened
        channel.subscribe('modal-open', function (data) {
            if (data.modal.is('[class*="reward"]')) {
                var $shareOptions = data.modal.find('.social-reward-modal__share-options');
                var offset = data.modal.offset().top;
                // reset the modal to the first step
                data.modal.find($steps).hide();
                data.modal.find('.social-reward-modal__step' + 1).show();
                scrollTo(offset);
                $shareOptions.removeClass('share-open');
                data.modal.find('.share').show();
            }
        });
    }

    function init() {
        initEvents();
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/rewarding/social-reward-modal.js
// module id = 40
// module chunks = 0